module.exports = __webpack_public_path__ + "img/kiwi-fruit.7a4bc337.svg";